import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import InSectionThree from '../../components/InSectionThree'

const fintechServices = [
   {
      title: 'Payments',
      image: '/assets/svg/industries/fintech/Payments.svg',
      description:
         'Building an integrated mobile payment app is essential for companies looking to provide smooth, encrypted transactions. Our skilled FinTech experts design and build end-to-end mobile payment solutions that facilitate secure money transfers, real-time payments, and digital rewards. For e-commerce, banking, or peer-to-peer applications, our solutions focus on easy-to-use experiences and best-in-class security.',
   },
   {
      title: 'InsurTech',
      image: '/assets/svg/industries/fintech/InsurTech.svg',
      description:
         'Streamline insurance operations with our tailored InsurTech solutions. From AI-driven risk evaluation to automated underwriting and IoT-driven claims processing, we develop smart applications that enhance operational efficiency. Our FinTech app developers design platforms that drive policyholder engagement while meeting changing regulations.',
   },
   {
      title: 'RegTech',
      image: '/assets/svg/industries/fintech/RegTech.svg',
      description:
         'Simplify compliance and regulatory risk management with our RegTech development services. Our cutting-edge solutions automate reporting, fraud detection, and regulatory compliance monitoring, keeping businesses compliant with legal frameworks with minimal risk. We embed AI-driven insights and real-time analytics to enhance governance and operational transparency.',
   },
   {
      title: 'Personal Finance',
      image: '/assets/svg/industries/fintech/PersonalFinance.svg',
      description:
         'Empower individuals with personal finance management solutions designed for budgeting, investment tracking, and spending monitoring. Our FinTech solutions draw insights from data to provide personalized financial advice, enabling individuals to make more intelligent money choices and attain their financial objectives effectively.',
   },
   {
      title: 'Accounting',
      image: '/assets/svg/industries/fintech/Accounting.svg',
      description:
         'Our custom accounting software programs do more than traditional bookkeeping. We craft clever accounting programs that handle transactions, simplify tax filing, and enrich financial reporting. With auto data processing and instantaneous reporting, businesses can streamline efficiency, precision, and adherence hassle-free.',
   },
   {
      title: 'Banking',
      image: '/assets/svg/industries/fintech/Banking.svg',
      description:
         'From retail banking to corporate finance, our FinTech solutions meet the changing demands of financial institutions. We develop user-friendly banking applications that provide real-time transaction monitoring, digital onboarding, and AI-driven financial insights. Our secure banking solutions provide hassle-free customer experience and increased security.',
   },
   {
      title: 'Wealth Management',
      image: '/assets/svg/industries/fintech/WealthManagement.svg',
      description:
         'Transform wealth management with our FinTech-driven investment platforms. We create secure, AI-enhanced applications that assist customers in tracking, managing, and growing their wealth. Our platforms support portfolio management, automated financial planning, and smart investment advisory, ensuring a seamless wealth management experience.',
   },
   {
      title: 'Lending and Mortgage',
      image: '/assets/svg/industries/fintech/LendingandMortgage.svg',
      description:
         'Modernize lending processes with our FinTech mortgage and loan software solutions. We build applications that enable instant loan approvals, automated credit scoring, and secure digital lending workflows. By integrating AI-powered risk analysis and compliance features, our lending platforms enhance efficiency while maintaining top-tier security.',
   },
];

function FintechSectionThree() {
   return (
      <section className="industries-bg-image">
         <div className="container">
            <p className="text-center cs-text-secondary tech_title section_heading_title mb-2">
               Customized FinTech Solutions to Drive <br/> Your Business Forward
            </p>
            <p className="section_desc cs-text-secondary mb-0">
               From online banking to wealth management, we specialize in developing future-forward FinTech solutions that contribute to business growth. We are a reliable FinTech app development firm that creates next-generation financial technology services that automate operations, boost security, and enhance customer experience. Our customized solutions address the complete financial spectrum, ensuring effective and scalable business change.
            </p>
         </div>
         <div className="position-relative">
            <InSectionThree itemData={fintechServices} />
         </div>
      </section>
   )
}

export default FintechSectionThree
